import axios from "axios";
import ReusableTable from "../ReusableTable/ReusableTable";
import classes from "./SLIPTAchecklist.module.css";
import { env } from "../../constants/env";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

const SLIPTAchecklist = () => {
  const { token } = useAuth();
  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(true);

  const sliptaColumns = [
    { label: "Date & Time Entered", field: "dateTime" },
    { label: "Laboratory Name", field: "labName" },
    { label: "HPCZ License Number", field: "license" },
    { label: "Physical Address", field: "address" },
    { label: "Facility Phone", field: "phone" },
    { label: "Facility Email", field: "email" },
  ];

  // Sample data
  const sliptaData = [
    {
      dateTime: "2025-05-05 10:30",
      labName: "Central Lab",
      license: "HPCZ-1234",
      address: "123 Lab Street",
      phone: "0123456789",
      email: "lab@example.com",
    },
  ];

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const formatted = res.data.map((lab) => ({
          dateTime: new Date(lab.createdAt).toLocaleString(),
          labName: lab.labName,
          license: lab.hpczLicense,
          address: lab.physicalAddress || "",
          phone: lab.telephone,
          email: lab.email,
          id: lab._id,
        }));
        setLabData(formatted);
      } catch (err) {
        console.error("Error fetching labs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLabs();
  }, []);
  return (
    <div className={classes.wrapper}>
      <ReusableTable
        title="SLIPTA Checklist"
        columns={sliptaColumns}
        data={labData}
        accreditationName="slipta"
      />
    </div>
  );
};

export default SLIPTAchecklist;
